import { render, staticRenderFns } from "./tool-cards.vue?vue&type=template&id=37b05acb&scoped=true"
import script from "./tool-cards.vue?vue&type=script&lang=js"
export * from "./tool-cards.vue?vue&type=script&lang=js"
import style0 from "./tool-cards.vue?vue&type=style&index=0&id=37b05acb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b05acb",
  null
  
)

export default component.exports